import { render, staticRenderFns } from "./book-topic-echarts.vue?vue&type=template&id=6e6ca6f8&scoped=true"
import script from "./book-topic-echarts.vue?vue&type=script&lang=js"
export * from "./book-topic-echarts.vue?vue&type=script&lang=js"
import style0 from "./book-topic-echarts.vue?vue&type=style&index=0&id=6e6ca6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ca6f8",
  null
  
)

export default component.exports